if($('header#header').length){

    $('.search-input').attr('placeholder', 'Jaký motiv hledáte?');
    $('.responsive-tools').prepend($('.top-navigation-tools .dropdown').clone())
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools'); 
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').before('<label for="password">Heslo<span>*</span></label>');
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner'); 
    
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    
     $(document).ready(function () {
        let target = 'cart';
        let timeout;
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on('mouseenter', function () {
            var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
            shoptet.popups.showPopupWindow(target, show);
        });

    });
}